import { Box, Modal, Group } from '@mantine/core'
import React, { useEffect, useState } from 'react'
import { useStyles } from './style'
import Button from "../../../utils/Button/index"
import Loading from '../../../utils/Loading'
import { MonthPicker } from '@mantine/dates';
import { getUserType } from '../../../config/userSession';
const MonthPickerModal = ({modalOpen, onClose, onYes}) => {

    const {classes,theme} = useStyles(useStyles);
    const [value, setValue] = useState(new Date() );
    const [loading , setLoading] = useState(false);
    const [selectedDueMonth, setSelectedDueMonth] = useState('');
    const [selectedDueYear, setSelectedDueYear] = useState('');
    const userType = getUserType();
    const handleCancel = () => {
        onClose()
      }
    
    const updateDueDate = () => {
      setSelectedDueMonth(value.getMonth());
      setSelectedDueYear(value.getFullYear());
      }
    useEffect( ()=>{
      updateDueDate()
    }, [value]) 
    

  return (
    <>
   {loading && <Loading/> }
    <Modal className={classes.wrapper} radius={20} onClose={handleCancel}  closeOnEscape={true} overlayProps={{
        opacity: 0.5
      }} size={"auto"} opened={modalOpen} centered closeButtonProps={{
        display: "none"
      }}>
        <Group position="center">
        <MonthPicker
        value={value}
        onChange={setValue}
        defaultDate={new Date()}
        maxDate={ userType === 'Tenant' ? new Date():null} 
      />
      </Group>
      <Box className={classes.actions}>
            <p onClick={handleCancel} className={classes.cancel}>Cancel</p>
            <Button className={classes.btn} onClick={() => onYes({selectedDueMonth, selectedDueYear})} title='Apply' bgColor={theme.colors.primary[0]}/>
          </Box>
      </Modal>
      </>
  )
}

export default MonthPickerModal